// extracted by mini-css-extract-plugin
export default {"reset":"CancelButton_reset__4IOT5","buttons":"CancelButton_buttons__FjI82"};